var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlagUs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 23V76.33H90V23H10Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 23L90 76.33L10 23ZM90 23L10 76.33Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 23L10 76.33M10 23L90 76.33L10 23Z",
    stroke: "white",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 23L90 76.33L10 23ZM90 23L10 76.33Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 23L10 76.33M10 23L90 76.33L10 23Z",
    stroke: "#C8102E",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 23V76.33V23ZM10 49.665H90Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 49.665H90M50 23V76.33V23Z",
    stroke: "white",
    strokeWidth: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 23V76.33V23ZM10 49.665H90Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 49.665H90M50 23V76.33V23Z",
    stroke: "#C8102E",
    strokeWidth: 12
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 53.33,
    fill: "white",
    transform: "translate(10 23)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagUs);
export default __webpack_public_path__ + "static/media/flag_us.67deaef8589f28278b3d9dec27356b2c.svg";
export { ForwardRef as ReactComponent };